
import { isCode, pub_reply, commentadd } from "@/views/post/api/index.ts";
import syEditor from "sy-editor-v3";
import toast from "@/views/post/components/toast.vue";
import GeetestSy from "geetest-sy";
import { getSm } from "@/utils/smsdkPromise.ts";
import { defineComponent } from "vue";
export default defineComponent({
  components: {
    toast
  },
  props: {
    post_id: {
      type: String
    },
    csrf: {
      type: String
    },
    reply_id: {
      type: String
    },
    comment_id: {
      type: String,
      default: ""
    },
    user_name: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      editor: {},
      editorImg: [],
      editorText: "",
      sm_device_id: "",
      uid: parseInt((window.globalData as any).uid || 0),
      challenge: "",
      time: new Date().getTime()
    };
  },
  mounted() {
    const editor = new syEditor(`editor${this.time}`);
    editor.config = {
      ...editor.config,
      ...{
        menus: ["emotion", "img"],
        emotions: {
          default: {
            title: "emoji",
            data: "/editor/emoji"
          }
        }
      },
      uploadImg: {
        uploadUrl:
          process.env.NODE_ENV === "development"
            ? "/mock/editor/picture"
            : "/editor/picture",
        imgLibrary: false,
        awaitImgCount: 9,
        imgTxtSeparation: true,
        uploadSuccess: ({ responseData }: any) => {
          this.editorImg = this.editorImg.concat(responseData);
          this.editorImg.length > 9 ? (this.editorImg.length = 9) : "";
        },
        // customResponse: (res: any) => {
        //   return res
        // },
        uploadParams: {
          type: 2,
          sys: 0
        }
      }
    };
    editor.create();
    editor.onchange = () => {
      this.editorText = (this.editor as any).$txt
        ? (this.editor as any).$txt.text()
        : "";
    };
    this.editor = editor;
    if (this.user_name) {
      (document.querySelector(`#editor${this.time}`) as any).blur();
      (this.editor as any).$txt.html(`回复 ${this.user_name}：`);
      if (window.getSelection) {
        const range: any = window.getSelection(); // 创建range
        range.selectAllChildren(
          document.querySelector(`#editor${this.time}`) as any
        ); // range 选择obj下所有子内容
        range.collapseToEnd(); // 光标移至最后
      }
    }
  },
  async created() {
    const res: any = await getSm();
    this.sm_device_id = res;
    //  极验
    // eslint-disable-next-line
    const that = this;
    const senseOptions = {
      initType: "sense", // 是否使用深知模式,不使用就不写
      initGt: {
        senseID: "94a6160514322a8c886c27dfae54770b", // 深知ID，如果使用深知模式必传，ID请找server确认，不同端不同页面都有可能不一致
        handler: function(sense: any) {
          sense
            .setInfos(function() {
              //设置可上传数据。请务必按照字段规范填写，否则会在服务验证时出错，导致程序无法运行或者后续数据分析出现混乱，参数需求参考api文档。
              return {
                interactive: 6
              };
            })
            .onSuccess(function(data: any) {
              console.log(data);
              that.challenge = data.challenge;
              that.submit();
            })
            .onClose(function() {
              console.log("close");
            })
            .onError(function(err: any) {
              console.log(err);
            });
          window.senseFn = sense;
        }
      }
    };
    new GeetestSy(senseOptions);
  },
  methods: {
    submit() {
      if (this.uid === 0) {
        window.sy.login.popup();
        return;
      }
      if (this.editorText.length < 2) {
        return;
      }
      let html = "";
      html += (this.editor as any).$txt.html();
      if (this.editorImg.length > 0) {
        this.editorImg.forEach((element: any) => {
          html += `<img src="${element.url}" watermark="${element.watermark}" width="${element.width}" height="${element.height}">`;
        });
      }
      isCode({}).then(({ errorCode, errorMsg, responseData }) => {
        if (errorCode === 0) {
          if (responseData.is_pop === 0) {
            if (this.reply_id) {
              commentadd({
                item_id: this.reply_id,
                class_id: 8,
                RichTextcontent: html,
                primary_id: this.post_id,
                anonymous: 0,
                str_type: "reply",
                sm_device_id: this.sm_device_id,
                challenge: this.challenge,
                comment_id: this.comment_id,
                notify_comment_id: this.comment_id
              }).then(({ errorCode, errorMsg, responseData }) => {
                if (errorCode === 0) {
                  this.editorImg = []; // 清空上传图片
                  (this.editor as any).$txt.html(""); // 清空文本框
                  responseData.comment.is_favor = 0;
                  this.$emit("getupdate", responseData.comment);
                } else {
                  (this.$refs.toast as any).show(errorMsg);
                }
              });
            } else {
              pub_reply({
                post_id: this.post_id,
                RichTextreply_content: html,
                CSRF_TOKEN: this.csrf,
                sm_device_id: this.sm_device_id,
                challenge: this.challenge
              }).then(({ status, msg, data }) => {
                if (status === 0) {
                  this.editorImg = []; // 清空上传图片
                  (this.editor as any).$txt.html(""); // 清空文本框
                  this.$emit("uplist", data.reply, data.csrf); //  更新数据
                } else {
                  (this.$refs.toast as any).show(msg);
                }
              });
            }
          } else {
            window.senseFn.sense();
          }
        } else {
          (this.$refs.toast as any).show(errorMsg);
        }
      });
    },
    delImg(e: any) {
      const index = e.currentTarget.dataset.index;
      this.editorImg.splice(index, 1);
    }
  },
  unmounted() {
    (this.editor as any).destroy && (this.editor as any).destroy();
    this.editor = {};
  }
});
